// extracted by mini-css-extract-plugin
module.exports = {"sortBtn":"SimpleTable_sortBtn__14XiR"};